import adminAxiosInstance from "../config";

function buildQuery(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.append(key, value);
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

function deriveFilename(defaultBase) {
  const date = new Date().toISOString().split("T")[0];
  return `${defaultBase}-${date}.xlsx`;
}

export async function exportData({ endpoint, params = {}, filenameBase }) {
  const query = buildQuery(params);
  const url = `${endpoint}${query}`;

  const response = await adminAxiosInstance.get(url, {
    responseType: "blob",
  });

  const blob = new Blob([response.data]);
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  const filename = deriveFilename(filenameBase || "export-data");
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export default exportData;


